<template>
  <div class="document-container">
    <div class="columns">
      <div class="column column-left is-three-quarters is-paddingless">
        <div class="flex-container-left">
          <div>
            <div class="document-container">
              <div class="document">
                <div class="header">
                  <es-header>
                    <template #header>
                      <div class="header-title">
                        Customize Report: Location by Group with Hierarchy
                      </div>
                    </template>
                  </es-header>
                </div>
                <div class="content">
                  <es-form>
                    <template #es-form-header>
                      <div class="header-container">
                        <div class="header-elements">
                          <font-awesome-icon :icon="['fas', 'filter']" size="lg" />
                        </div>
                        <div class="header-elements">
                          <h6 class="title">
                            Filter Type
                          </h6>
                        </div>
                      </div>
                    </template>
                    <template #es-form>
                      <div class="field is-horizontal">
                      </div>
                      <div class="field is-horizontal">
                        <div class="field-label">
                          <label class="label">Location Group</label>
                        </div>
                        <div class="field-body">
                          <div class="field is-narrow">
                            <div class="control is-expanded">
                              <popper
                                ref="groupSearch"
                                trigger="click"
                                :options="{
                                  placement: 'bottom',
                                  priority: 'bottom',
                                  arrow: false,
                                }">
                                <div class="popper">
                                  <div
                                    class="search-result"
                                    @click="stageLocation(searchResult)"
                                    v-for="searchResult in searchResults.data"
                                    :key="searchResult.id">
                                    <span>
                                      {{ searchResult.code || "N/A" }}
                                      - {{ searchResult.label || "N/A"}}
                                    </span>
                                  </div>
                                </div>
                                <input
                                  slot="reference"
                                  class="input location-search"
                                  :class="{ 'is-danger': hasErrorName }"
                                  v-model="searchName"
                                  type="text"
                                  placeholder="All or search a specific group"
                                  @keyup="checkLength"/>
                              </popper>
                            </div>
                            <span v-if="hasErrorName" class="help is-danger">
                              {{ searchNameMsg }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="field is-horizontal">
                        <div class="field-label">
                          <label class="label">Status</label>
                        </div>
                        <div class="field-body">
                          <div class="field is-narrow">
                            <div class="control">
                              <label class="radio">
                                <input type="radio" v-model="status" value="ALL"
                                name="status">
                                All
                              </label>
                              <label class="radio">
                                <input type="radio" v-model="status" value="ACTIVE"
                                name="status">
                                Active
                              </label>
                              <label class="radio">
                                <input type="radio" v-model="status" value="INACTIVE"
                                name="status">
                                Inactive
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="header-container">
                          <div class="header-elements">
                            <font-awesome-icon :icon="['fas', 'file-edit']" size="lg" />
                          </div>
                          <div class="header-elements">
                            <h6 class="title">
                              Format
                            </h6>
                          </div>
                        </div>
                        <div class="field is-horizontal">
                        </div>
                        <div class="field is-horizontal">
                          <div class="field-label">
                            <label class="label">File Format</label>
                          </div>
                          <div class="field-body">
                            <div class="field is-narrow">
                              <div class="control">
                                <label>
                                  <input type="text" class="is-hidden" v-model="delim" value="COMMA"
                                   name="delim">&nbsp;
                                  <font-awesome-icon :icon="['fas', 'file-csv']" size="lg"
                                   class="text-green"/> CSV
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="field is-horizontal">
                        </div>
                        <div class="field is-horizontal">
                          <div class="field-label">
                            <label class="label">Qualifier</label>
                          </div>
                          <div class="field-body">
                            <div class="field is-narrow">
                              <div class="control">
                                <label class="radio">
                                  <input type="radio" v-model="qual" value="NONE"
                                  name="qual">
                                  None
                                </label>
                                <label class="radio">
                                  <input type="radio" v-model="qual" value="DOUBLE_QUOTES"
                                  name="qual">
                                  Double Quotes
                                </label>
                                <label class="radio">
                                  <input type="radio" v-model="qual" value="SINGLE_QUOTES"
                                  name="qual">
                                  Single Quotes
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                    </template>
                  </es-form>
                </div>
                <div class="es-actions">
                  <es-form-actions>
                    <template #form-actions>
                      <div class="bottom-content">
                        <ul>
                          <li class="reset">
                            <div class="list-content">
                              <a @click="$router.push(
                                { name: 'reportsmainl' }
                              )">
                                Cancel
                              </a>
                            </div>
                          </li>
                          <li>
                            <div class="list-content">
                              <button
                                class="button is-primary"
                                 @click="post"
                                >
                                  Generate
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </es-form-actions>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column column-right is-one-quarter is-paddingless">
        <div class="flex-container-right">
          <div class="document-container">
            <div class="document" name="instructions">
              <div class="header">
                <es-header>
                  <template #header>
                    <div class="header-title">Instructions</div>
                  </template>
                </es-header>
              </div>
              <div class="activity-row">
                <div class="activity-row-container">
                  <div class="activity-summary">
                    <div class="activity-status activity-element">
                      <div>
                        <span class="has-text-grey">
                          This page allows you to customize the report by
                          making selections in Filter By and Format sections.
                        </span>
                      </div>
                      <div>
                        <span class="has-text-weight-bold">
                          Filter By
                        </span>
                      </div>
                      <div>
                        <span class="has-text-grey">
                          You may filter the report by selecting filter fields
                          available on the page.
                          Some fields are pre-selected as default.
                          <br>
                          For the <i>Location Group</i> selection box, the
                          default selection is All for all groups. You may
                          search a specific group by typing in group name, and
                          select the group from the dropdown list with matching
                          word.
                        </span>
                      </div>
                      <div>
                        <span class="has-text-weight-bold">
                          Format
                        </span>
                      </div>
                      <div>
                        <span class="has-text-grey">
                          You may select proper file format and qualifier for
                          downloaded file.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFileCsv,
  faFileEdit,
  faFilter,
  faMapMarkerAlt,
  faNotEqual,
} from '@fortawesome/pro-light-svg-icons';
import {
  faFileCsv as faFileCsvSolid,
  faFileEdit as faFileEditSolid,
  faFilter as faFilterSolid,
} from '@fortawesome/pro-solid-svg-icons';

import popper from 'vue-popperjs';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import 'vue-popperjs/dist/vue-popper.css';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faAngleRight,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFileCsv,
  faFileCsvSolid,
  faFileEdit,
  faFileEditSolid,
  faFilter,
  faFilterSolid,
  faMapMarkerAlt,
  faNotEqual,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
    popper,
  },
  data() {
    return {
      searchName: null,
      searchResults: [],
      status: 'ALL',
      reportType: 'GROUP_HEIRARCHY',
      delim: 'COMMA',
      qual: 'NONE',
      groupId: '',
      locationgroupList: [],
      hasErrorName: false,
      searchNameMsg: '',
      showPopper: false,
      formErrorMsg: 'There were some errors. Please try again. If errors persist please contact support.',
    };
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
  },
  async mounted() {
    this.setBreadcrumbs();
    try {
      const res = await axios.get('location-groups');
      this.locationgroupList = res.data.data;
    } catch (err) {
      console.error(err);
      this.messages.push(this.formErrorMsg);
      this.showNotification('danger', this.messages);
    }
  },
  methods: {
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'groupList' } },
        { text: 'Reports', to: { name: 'reportsmainl' } },
        { text: 'Location by Group with Hierarchy', to: {} },
      ]);
    },
    resetForm() {
      this.status = 'ALL';
      this.delim = 'COMMA';
      this.qual = 'NONE';
      this.groupId = '';
    },
    stageLocation(searchResult) {
      this.groupId = searchResult.id;
      this.searchName = searchResult.label;
      this.search();
      this.togglePopper();
    },
    toggleAdd() {
      this.isAdding = !this.isAdding;
    },
    resetErrors() {
      this.hasErrorName = false;
      this.searchNameMsg = null;
    },
    togglePopper() {
      this.$refs.groupSearch.showPopper = !this.$refs.groupSearch.showPopper;
    },
    clickPopper() {
      if (this.searchResults === null) {
        this.$refs.groupSearch.showPopper = false;
      } else {
        this.$refs.groupSearch.showPopper = false;
      }
    },
    checkLength() {
      this.resetErrors();
      if (this.searchName === null) {
        this.$refs.groupSearch.showPopper = false;
      } else if ( this.searchName.length == 0 || this.searchName.length >= 3 ) {
        if ( this.searchName.length >= 3 ) {
          this.$refs.groupSearch.showPopper = true;
          this.search();
        }
        return true;
      } else {
        this.$refs.groupSearch.showPopper = false;
        this.searchResults = [];
        this.searchNameMsg = 'Please enter at least 3 characters';
        this.hasErrorName = true;
        return false;
      }
    },
    async search() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        try {
          const res = await axios.get(`/location-groups?q=${this.searchName.trim()}&pageSize=10`);
          // console.log(res);

          if (res) {
            if (res.data.totalCount === 0) {
              this.searchNameMsg = 'Group name is invalid';
              this.hasErrorName = true;
              this.$refs.groupSearch.showPopper = false;
              this.searchResults = [];
            } else {
              this.searchResults = res.data;
            }
          }
        } catch (err) {
          console.log(err);
          this.messages.push(this.formErrorMsg);
          this.showNotification('danger', this.messages);
        }
      }, 500);
    },
    async post() {
      // console.log(this.$route.params.reportType);
      // Local Code || State Location Id
      if ( !this.hasErrorName ) {
        try {
          const res = await axios.post('/reports/', ({
            status: this.status,
            delim: this.delim,
            qual: this.qual,
            reportType: this.reportType,
            groupId: this.groupId,
          }));
          this.$emit('reportCreated', res.data);
          this.$router.push('/locationID/reports');
        } catch (err) {
          console.error(err);
          this.messages.push(this.formErrorMsg);
          this.showNotification('danger', this.messages);
        }
      }
    },
  },
};
</script>

  <style lang="sass" scoped>
    @import "~bulma/sass/utilities/_all"
    // @import "~bulma/bulma"
    +tablet
      .add-container
        display: flex
      .wrap
        -webkit-flex-wrap: wrap
        flex-wrap: wrap
    .flex-item
      min-width: 155px
      margin: 0rem 1rem 1rem 0rem
      text-align: center
    .input
      width: 200px
    .popper
      background-color: #fff !important
      -webkit-box-shadow: none !important
      box-shadow: none !important
      width: 100% !important
      padding: 8px 0px !important
      text-align: left
      padding: 0 !important
      margin: 0 !important
      border: 0px
      .search-result
        font-size: .85rem
        display: flex
        align-items: center
        min-height: 30px
        padding-left: .5rem !important
        padding-right: .5rem !important
        width: 100%
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        border: 0px
        &:hover
          background-color: #1E90FF
          color: #fff
          border: 0px
      .popper__arrow
        visibility: hidden
        top: 0px
      a
        padding: 4px 24px
        height: 25px
        &:hover
          color: #5953A4 !important
    .text-muted
      color: #6c757d !important
    .activity-row
      border-top: 1px solid rgb(222, 226, 230)
    .activity-row-container
      padding: .5rem 1rem
      display: flex
    .icon-column
      min-width: 40px
      display: flex
      align-items: flex-start
    .activity-summary
      font-size: .85rem
      display: flex
      flex-direction: column
      align-items: flex-start
    .activity-element
      padding-top: 4px
      padding-bottom: 4px
      text-align: left
    .activity-status
      text-align: left
    .text-green
      color: #55a156
  </style>
